import { AuthGuard } from "@dis/auth";
import { JtmsRoutes } from "../core/routing/route-data";
import { meetingDetailRoutes } from "../feature/dashboards/meeting-mode/meeting-detail.routes";

export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "dashboards" },
    children: [
      // Home stays at /home, its own top-level nav item. No Overview here: the group opens on its first dashboard.
      { path: "", pathMatch: "full", redirectTo: "operations-timeline" },
      {
        path: "meeting-room",
        // Always last in the group, below any dashboards added later.
        data: { navOrder: Number.MAX_SAFE_INTEGER },
        loadComponent: () =>
          import("../feature/dashboards/meeting-mode/meeting-mode/meeting-mode.component").then(
            (m) => m.MeetingModeComponent
          ),
        title: "Meeting Room",
        // Project/job/shipment pages in the side panel (meetingDetail outlet).
        children: meetingDetailRoutes,
      },
      {
        path: "operations-timeline",
        data: { navOrder: 1 },
        loadComponent: () =>
          import("../feature/dashboards/operations-timeline/operations-timeline").then((m) => m.OperationsTimeline),
        title: "Operations Timeline",
      },
      {
        path: "reports",
        data: { navOrder: 2 },
        loadComponent: () => import("../layout/reports-hub/reports-hub").then((m) => m.ReportsHub),
        title: "Reports",
      },
    ],
  },
] satisfies JtmsRoutes;
